import { Injector, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

export function translationsReady(injector: Injector) {
  const translateService = inject(TranslateService);
  return () => translateService.get('default');
};
